<template>
<div class="chapter">
<div class="inner_page">
<h2 class="calibre2" id="pgepubid00004">PREFACE.</h2>
<p class="calibre5">Feeling anxious to preserve for future reference an account of the part which the Negro took in suppressing the Slaveholders’ Rebellion, I have been induced to write this work. In doing so, it occurred to me that a sketch of the condition of the race previous to the commencement of the war would not be uninteresting to the reader.</p>
<p class="calibre5">For the information concerning the services which the blacks rendered to the Government in the Revolutionary War, I am indebted to the late George Livermore, Esq., whose “Historical Research” is the ablest work ever published on the early history of the negroes of this country.</p>
<p class="calibre5">In collecting facts connected with the Rebellion, I have availed myself of the most reliable information that could be obtained from newspaper correspondents, as well as from those who were on the battle-field. To officers and privates of several of the colored regiments I am under many obligations for detailed accounts of engagements.</p>
<p class="calibre5">No doubt, errors in fact and in judgment will be discovered, which I shall be ready to acknowledge, and correct in subsequent editions. The work might have been swelled to double its present size; but I did not feel bound to introduce an account of every little skirmish in which colored men were engaged.</p>
<p class="calibre5">I waited patiently, before beginning this work, with the hope that some one more competent would take the subject in hand; but, up to the present, it has not been done, although many books have been written upon the Rebellion.</p>
<h3 class="calibre8 sigil_not_in_toc" id="pgepubid00005">WILLIAM WELLS BROWN.</h3>
<p class="calibre5">Cambridgeport, Mass., Jan. 1, 1867.</p>
<div class="calibre9" id="calibre_pb_2"></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0002.vue?2008d699